module.exports = __webpack_public_path__ + "img/bg-form-opening-positions-mobile.c5823bb9.svg";